import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISimApnModel } from '@apps-common/types/management/sim-apn'

export const getSimApn = async (apnId: string): Promise<ISimApnModel> =>
  axios.get(`/management/simapn/getsimapn?apnId=${apnId}`).then((res) => res.data?.data)

type QueryFnType = typeof getSimApn

type Props = {
  config?: QueryConfig<QueryFnType>
  apnId: string
}

export const useManagementGetSimApn = ({ config, apnId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getSimApn', apnId],
    queryFn: () => getSimApn(apnId)
  })
